import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

export * from './lib';
